import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import fileDownload from 'js-file-download';

import {
	getUploadedFilesRequest,
	getUploadedFilesSuccess,
	uploadFileRequest,
	uploadFileSuccess,
	downloadFileRequest,
	downloadFileSuccess,
} from './reducer';
import {
	TEmProductFileUploadsRequest,
	TEmProductFileUploadsResponsePayload,
	TEmProductFileUploadRequest,
	TEmProductFileDownloadRequest,
} from './types';

function* getUploadedFilesWorker(
	action: PayloadAction<TEmProductFileUploadsRequest>,
): Generator<any, void, any> {
	const { payload } = action;
	try {
		const response: TEmProductFileUploadsResponsePayload = yield call(
			api.emProductFileUploads.getUploadedFiles,
			payload,
		);
		yield put(getUploadedFilesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* uploadFileWorker(
	action: PayloadAction<TEmProductFileUploadRequest>,
): Generator<any, void, any> {
	const { payload } = action;
	try {
		yield call(api.emProductFileUploads.uploadFile, payload.file);
		yield put(uploadFileSuccess());
		yield put(getUploadedFilesRequest(payload.uploadedFilesRequest));

		notificationContainer(
			'Your file sent for processing. You will be notified via email when processing is finished',
			'success',
		);
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
		yield put(uploadFileSuccess());
	}
}

function* downloadFileWorker(
	action: PayloadAction<TEmProductFileDownloadRequest>,
): Generator<any, void, any> {
	const { payload } = action;
	try {
		const blob = payload.processed
			? yield call(api.emProductFileUploads.downloadProcessedFile, payload.id)
			: yield call(api.emProductFileUploads.downloadFile, payload.id);
		yield put(downloadFileSuccess());
		if (blob) {
			fileDownload(blob, payload.fileName);
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
		yield put(downloadFileSuccess());
	}
}

export function* emProductFileUploadsSaga(): Generator<any, void, any> {
	yield takeEvery(getUploadedFilesRequest.type, getUploadedFilesWorker);
	yield takeEvery(uploadFileRequest.type, uploadFileWorker);
	yield takeEvery(downloadFileRequest.type, downloadFileWorker);
}
